import { render, staticRenderFns } from "./PreviewAgreement.vue?vue&type=template&id=55a996d8&scoped=true&"
import script from "./PreviewAgreement.vue?vue&type=script&lang=ts&"
export * from "./PreviewAgreement.vue?vue&type=script&lang=ts&"
import style0 from "./PreviewAgreement.vue?vue&type=style&index=0&id=55a996d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a996d8",
  null
  
)

export default component.exports